import { render, staticRenderFns } from "./AudienceList.vue?vue&type=template&id=fc0441f0&scoped=true&"
import script from "./AudienceList.vue?vue&type=script&lang=js&"
export * from "./AudienceList.vue?vue&type=script&lang=js&"
import style0 from "./AudienceList.vue?vue&type=style&index=0&id=fc0441f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0441f0",
  null
  
)

export default component.exports